export const STEAM_JOURNEY_TO_ECHO =
    "https://store.steampowered.com/app/4895560/Journey_to_Echo/";

export const DISCORD_URL = "https://discord.gg/RMazmP6Xjr";
export const INSTAGRAM_URL = "https://www.instagram.com/northruinsgames/";
export const WEBSITE_URL = "https://northruins.com/";

export const JOURNEY_SCREENSHOTS = [
    "journey1.png",
    "journey2.png",
    "journey5.png",
    "journey6.png",
] as const;

export const getPublicImage = (imageName: string) => `/${imageName}`;
